"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ServiceProvider2 = _interopRequireDefault(require("../ServiceProvider"));

var _EventServiceProvider = _interopRequireDefault(require("./EventServiceProvider"));

var _ConfigServiceProvider = _interopRequireDefault(require("./ConfigServiceProvider"));

var _LogServiceProvider = _interopRequireDefault(require("./LogServiceProvider"));

var AppServiceProvider =
/*#__PURE__*/
function (_ServiceProvider) {
  (0, _inherits2["default"])(AppServiceProvider, _ServiceProvider);

  function AppServiceProvider() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, AppServiceProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(AppServiceProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "providers", [new _EventServiceProvider["default"](_this.app), new _ConfigServiceProvider["default"](_this.app), new _LogServiceProvider["default"](_this.app)]);
    return _this;
  }

  (0, _createClass2["default"])(AppServiceProvider, [{
    key: "register",

    /**
     * Register.
     */
    value: function register() {
      var _this2 = this;

      var config = this.app.get('config'); // expose the app to a global

      if (config.hasThrough('app.name')) {
        window[config.getThrough('app.name')] = this.app;
      } // register providers from config


      config.getThrough('app.providers', []).forEach(function (provider) {
        _this2.app.register(provider);
      });
    }
  }]);
  return AppServiceProvider;
}(_ServiceProvider2["default"]);

exports["default"] = AppServiceProvider;